<script>
  import { get, call } from 'vuex-pathify'
  import screen from '@/helpers/screen'
  import LogoAlltrue from '@/images/logos/LogoAlltrue.svg'

  export default {
    components: {
      LogoAlltrue,
    },
    computed: {
      ...get('prismic', ['getSubscribePageData', 'getShippingData']),
      screen,
      footerShippingText() {
        const shippingField =
          this.getShippingData?.footer_shipping_text ??
          this.getSubscribePageData?.footer_shipping_text

        if (!shippingField) {
          return null
        }

        if (Array.isArray(shippingField)) {
          const textContent = shippingField
            .map((block) => block?.text)
            .filter(Boolean)
            .join(' ')
            .trim()
          return textContent || null
        }

        if (typeof shippingField === 'object' && 'text' in shippingField) {
          return shippingField.text
        }

        return shippingField
      },
      planItems() {
        // console.log(this.getSubscribePageData)
        return this.getSubscribePageData
      },
      messageText() {
        return this.getSubscribePageData?.landing_page_promo_message
      },
      messageImage() {
        return this.getSubscribePageData?.landing_page_promo_image
      },
    },
    created() {
      this.loadSubscriptionBoxandPlan()
      this.loadShippingTimelines()
    },
    methods: {
      ...call('prismic', ['loadSubscriptionBoxandPlan', 'loadShippingTimelines']),
    },
  }
</script>

<template>
  <div class="mb-14">
    <BaseDivider :weight="2" color="black" class="mb-6" />

    <!--Multiple Boxes Content-->
    <div class="max-w-110 text-center my-14 mx-auto px-3">
      <img
        v-if="messageImage"
        class="m-auto mb-8 max-w-42"
        :src="messageImage.url"
        :alt="messageImage.alt ? messageImage.alt : 'Alltrue Banner Image'"
      />
      <p class="font-heading font-medium text-3xl">
        {{ messageText }}
      </p>
    </div>

    <BaseDivider :weight="1" color="black" class="mb-14" />
    <div class="flex items-center justify-center mb-8">
      <a
        class="max-h-11 flex items-center justify-center border border-black p-2 rounded-sm"
        href="https://alltrue.com/gift"
      >
        <div class="bg-black h-7 flex items-center px-1" style="border-radius: 3px">
          <BaseIcon class="text-dawn">
            <LogoAlltrue class="w-8" />
          </BaseIcon>
        </div>
        <div class="font-bold text-2xs ml-2 mr-6px leading-close"> Gifting? Learn more here </div>
        <BaseIcon :size="3" class="text-black">
          <IconChevronRightThick />
        </BaseIcon>
      </a>
    </div>
    <p class="text-sm lg:text-base text-center leading-close italic lg:not-italic">
      {{ footerShippingText }}
    </p>
  </div>
</template>

<style lang="postcss" scoped>
  .max-width-two-cards {
    @apply px-3;

    @screen sm {
      @apply px-0;

      max-width: 404px;
    }

    @screen md {
      max-width: 476px;
    }

    @screen lg {
      max-width: 640px;
    }

    @screen xl {
      max-width: 728px;
    }
  }

  .max-width-three-cards {
    @apply px-3;

    @screen sm {
      @apply px-0;

      max-width: 612px;
    }

    @screen md {
      max-width: 720px;
    }

    @screen lg {
      max-width: 990px;
    }

    @screen xl {
      max-width: 1104px;
    }
  }
</style>
